import React from 'react'
import { AdvancedFilter } from 'components/Filter/AdvancedFilter'
import { TotalDepreciationDetail } from './TotalDepreciationDetail/TotalDepreciationDetail'
import { TotalDepreciationMain } from './TotalDepreciationMain'
import { TotalDepreciationForm } from './TotalDepreciationForm/TotalDepreciationForm'

const totalDepreciationRoutes = [
  /* -------------------------------------------- */
  /*                ADVANCED FILTER               */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/total-depreciation/filter',
    },
    component: (
      <AdvancedFilter
        mode="assets-change"
        app="fixed-assets"
        hasStatus
        hasDocDate
        hasDateRange
      />
    ),
  },

  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/total-depreciation',
    },
    component: <TotalDepreciationMain />,
  },

  /* -------------------------------------------- */
  /*                     FORM                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/total-depreciation/add',
    },
    component: <TotalDepreciationForm formMode="add" type="ASSETS_REGISTRATION" />,
  },
  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/total-depreciation/edit',
    },
    component: <TotalDepreciationForm formMode="edit" />,
  },
  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/total-depreciation/resubmit',
    },
    component: <TotalDepreciationForm formMode="resubmit" />,
  },

  /* -------------------------------------------- */
  /*                    DETAIL                    */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/total-depreciation/detail',
    },
    component: <TotalDepreciationDetail />,
  },
]

export default totalDepreciationRoutes
